import { render, staticRenderFns } from "./UserSelectDropdown.vue?vue&type=template&id=b2a1d5ee&scoped=true&"
import script from "./UserSelectDropdown.vue?vue&type=script&lang=js&"
export * from "./UserSelectDropdown.vue?vue&type=script&lang=js&"
import style0 from "./UserSelectDropdown.vue?vue&type=style&index=0&id=b2a1d5ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a1d5ee",
  null
  
)

export default component.exports